var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM4.26458 20H7.58184V9.31771H4.26458V20ZM4 5.92114C4 6.98171 4.8606 7.86057 5.92121 7.86057C6.98182 7.86057 7.84242 6.98171 7.84242 5.92114C7.84242 5.41162 7.64001 4.92297 7.27971 4.56269C6.91942 4.20241 6.43075 4 5.92121 4C5.41167 4 4.92301 4.20241 4.56271 4.56269C4.20241 4.92297 4 5.41162 4 5.92114ZM16.6873 20H19.9971H20V14.132C20 11.2606 19.3828 9.04972 16.0256 9.04972C14.4118 9.04972 13.33 9.93543 12.8872 10.7749H12.8409V9.31771H9.65963V20H12.9735V14.7109C12.9735 13.3177 13.238 11.9714 14.9627 11.9714C16.6622 11.9714 16.6873 13.5606 16.6873 14.8V20Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.bd2d43b4ef183471b3d0abc88d928b00.svg";
export { ForwardRef as ReactComponent };